"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = exports.textField = void 0;

var _input = require("./input.const");

var _font = _interopRequireDefault(require("../choices/font.const"));

var _size = _interopRequireDefault(require("../choices/size.const"));

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }

var textField = {
  input: _input.input,
  label: {
    labelPadding: "0 ".concat(_size["default"]["default"], " 0 0"),
    labelMinWidth: 'initial'
  },
  descriptionFontFamily: _font["default"].family,
  descriptionFontSize: _font["default"].sizeXs,
  descriptionFontStyle: 'normal',
  descriptionFontWeight: _font["default"].weightDefault,
  descriptionLineHeight: _font["default"].lineHeightXs
};
exports.textField = textField;
var _default = textField;
exports["default"] = _default;